<!-- 嵌入式-配件库存管理 -->
<template>
  <el-card>
    <div class="toolbar">
      <div class="former">
        <select2
          labelName="NameNumber"
          v-model="former.DciAccessoryModelID"
          url="dci/model/accessory/list?order=name"
          clearable
          placeholder="选择配件型号"
          no-data-text="没有配件型号"
          :urlParams="{
            where: {},
          }"
          q="NameNumber:like"
          :qinwhere="true"
          :queryOne="false"
        ></select2
        >&nbsp;
        <el-input
          v-model.trim="former['SN:like']"
          placeholder="输入配件SN"
          @keydown.enter.native="onSubmitQuery"
        >
        </el-input
        >&nbsp;
        <el-select
          v-model="former.ClientName"
          placeholder="输入客户"
          filterable
          clearable
        >
          <el-option
            v-for="client in clientList"
            :key="client"
            :label="client"
            :value="client"
          ></el-option> </el-select
        >&nbsp;
        <el-select
          v-model="former.Tags"
          multiple
          collapse-tags
          placeholder="请选择标签"
          filterable
          clearable
        >
          <el-option
            v-for="(tag, index) in tagList"
            :key="index"
            :label="tag"
            :value="tag"
          ></el-option> </el-select
        >&nbsp;
        <select2
          labelName="Value"
          valueKey="Key"
          v-model="former.Status"
          url="dci/accessory/stock-status-list"
          clearable
          placeholder="配件状态"
          no-data-text="没有状态"
          style="width: 100px"
        ></select2
        >&nbsp;
        <el-button type="primary" @click="onSubmitQuery">
          <i class="fas fa-search"></i>
        </el-button>
      </div>
    </div>
    <el-table :data="itemList" v-loading="loading" size="medium">
      <el-table-column
        type="index"
        :index="pager.size * (pager.page - 1) + 1"
        :width="Math.max(48, (pager.size * pager.page).toString().length * 12)"
      />
      <el-table-column prop="DciAccessoryModel.Name" label="配件型号名称" />
      <el-table-column prop="DciAccessoryModel.Number" label="配件型号" />
      <el-table-column prop="SN" label="配件SN" >
         <template slot-scope="{ row }">
          <el-tag>
            {{ row.SN }}
          </el-tag>
        </template>
      </el-table-column> 
      <el-table-column prop="DciProduct.SN" label="关联产品SN" width="160" >
         <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.DciProduct !== null">
            {{ scope.row.DciProduct.SN }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="标签" width="120">
        <template slot-scope="{ row }">
          <el-tag
            v-for="tag in row.Tags"
            :key="tag"
            style="margin-right: 5px; color: #00b3ca"
            >{{ tag }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column prop="ClientName" label="客户" width="120" />
      <el-table-column prop="IsQuality" label="是否在保" align="center" width="80">
        <template slot-scope="{ row }">
          <el-tag v-if="row.IsQuality === '是'" type="success"> 在保 </el-tag>
          <el-tag v-else-if="row.IsQuality === '否' && row.QualityEndAt !== null && row.QualityEndAt !== undefined" type="warning"> 过保 </el-tag>
          <el-tag v-else type="info"> 未知 </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="StatusName" label="状态" align="center" width="80">
        <template slot-scope="{ row }">
          <el-tag v-if="row.Status === 1" type="warning">
            {{ row.StatusName }}
          </el-tag>
          <el-tag v-else type="success">
            {{ row.StatusName }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column width="100" label="操作">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.Status === 1"
            type="primary"
            @click.stop="onOutItem(scope.row)"
            title="出库"
          >
            <i class="fas fa-sign-in-alt"></i>
          </el-button>
          <el-button
            v-else
            type="primary"
            @click.stop="onEditItem(scope.row)"
            title="编辑"
          >
            <i class="fas fa-pencil-alt"></i>
          </el-button>
          <el-button
            type="danger"
            @click.stop="onDeleteItem(scope.row)"
            title="删除"
            v-permission="'dci_accessory_stock-DELETE'"
          >
            <i class="fas fa-trash-alt"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      >
      </el-pagination>
    </div>
    <out v-model="item" :visible.sync="outVisible" @form:saved="flush" />
    <edit v-model="item" :visible.sync="editVisible" @form:saved="flush" />
  </el-card>
</template>

<script>
import Out from "./out.vue";
import Edit from "./edit.vue";

export default {
  components: {
    Out,
    Edit,
  },
  data() {
    return {
      itemList: [],
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      former: {
        DciAccessoryModelID: "",
        Status: "",
        ClientName: "",
        "SN:like": "",
        Tags: [],
      },
      item: this.getEmptyItem(),
      createVisible: false,
      outVisible: false,
      editVisible: false,
      tagList: [],
      clientList: [],
    };
  },
  created() {
    this.getItemList();
    this.getTagList();
    this.getClientList();
  },
  methods: {
    flush() {
      this.getItemList();
      this.getTagList();
      this.getClientList();
    },
    getTagList() {
      this.$axios
        .get("dci/accessory/stock-tags")
        .then((response) => {
          this.tagList = response.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    getClientList() {
      this.$axios
        .get("dci/accessory/stock-clients")
        .then((response) => {
          this.clientList = response.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    getItemList() {
      this.loading = true;
      this.$axios
        .get("dci/accessory/stock-list", {
          params: {
            where: {
              DciAccessoryModelID: this.former.DciAccessoryModelID,
              Status: this.former.Status,
              ClientName: this.former.ClientName,
              "SN:like": this.former["SN:like"],
            },
            Tags: this.former.Tags,
            ...this.pager,
            with: ["DciAccessoryModel", "DciProduct"],
            order: ["-stockin_at", "-sn"],
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, "size", "page", "total");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onCreateItem() {
      this.item = this.getEmptyItem();
      this.createVisible = true;
    },
    onOutItem(row) {
      this.item = row;
      this.outVisible = true;
    },
    onEditItem(row) {
      this.item = row;
      this.editVisible = true;
    },
    onDeleteItem(row) {
      this.$confirm("确定要删除此配件吗？", "提示")
        .then(() => this.$axios.delete(`dci/accessory/stock-delete/${row.ID}`))
        .then(() => {
          this.getItemList();
          this.$message.success("删除成功");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    getEmptyItem() {
      return {};
    },
    onSubmitQuery() {
      this.pager.page = 1;
      this.getItemList();
    },
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
  },
};
</script>
